import React from 'react'

import ThreeDotsLoadingSpinner from 'components/Common/LoadingSpinner/threeDots'
import { Button as MuiButton, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'

import { PRIMARY_BUTTON, SECONDARY_BUTTON, EMPHASIZED_BUTTON, DISABLED_BUTTON } from 'themes/theme'

const Button = ({ children, ...props }) => {
  const theme = useTheme()
  const { fullWidth, type, loading, submit, negative, disabled, onClick, role, sx, ...rest } = props

  let textColor = theme.palette.text.white
  let background = negative ? theme.palette.background.negativePrimary : theme.palette.background.primary
  let backgroundHover = negative ? theme.palette.background.negativePrimaryHover : theme.palette.background.primaryHover

  switch (type) {
    case PRIMARY_BUTTON:
      break
    case SECONDARY_BUTTON:
      textColor = negative ? theme.palette.color.negative : theme.palette.text.secondary
      background = negative ? theme.palette.background.negativeSecondary : theme.palette.background.secondary
      backgroundHover = negative
        ? theme.palette.background.negativeSecondaryHover
        : theme.palette.background.secondaryHover
      break
    case EMPHASIZED_BUTTON:
      background = theme.palette.background.emphasized
      break
    case DISABLED_BUTTON:
      textColor = theme.palette.color.darkBlue70
      background = theme.palette.color.darkBlue20
      break
    default:
      break
  }

  if (type === SECONDARY_BUTTON) {
    return (
      <MuiButton
        type={submit ? "submit" : 'button'}
        role={role}
        onClick={onClick}
        sx={{
          maxWidth: '100%',
          padding: 0,
          width: fullWidth ? '100%' : 'auto',
          paddingX: {
            xs: '15px',
            sm: '15px',
            md: '20px',
            lg: '30px',
          },
          height: {
            xs: '40px',
            sm: '40px',
            md: '40px',
            lg: '40px',
          },
          border: '2px solid transparent',
          background: background,
          borderRadius: '30px',
          '&:hover': {
            background: backgroundHover,
          },
          ...sx,
        }}
        {...rest}
      >
        <Typography
          component="span"
          variant="button1"
          sx={{
            textTransform: 'capitalize',
            color: textColor,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          }}
        >
          {loading ? <ThreeDotsLoadingSpinner width={'50px'} /> : children}
        </Typography>
      </MuiButton>
    )
  } else {
    return (
      <MuiButton
        type={submit ? "submit" : 'button'}
        onClick={onClick}
        role={role}
        disabled={type === DISABLED_BUTTON}
        sx={{
          maxWidth: '100%',
          padding: 0,
          borderRadius: '30px',
          width: fullWidth ? '100%' : 'auto',
          paddingX: {
            xs: '15px',
            sm: '15px',
            md: '20px',
            lg: '30px',
          },
          height: {
            xs: '40px',
            sm: '40px',
            md: '40px',
            lg: '40px',
          },
          background: background,
          '&:hover': {
            background: backgroundHover,
          },
          ...sx,
        }}
        {...rest}
      >
        <Typography
          component="span"
          variant="button1"
          sx={{
            textTransform: 'capitalize',
            color: textColor,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          }}
        >
          {loading ? <ThreeDotsLoadingSpinner width={'50px'} fillColor="white" /> : children}
        </Typography>
      </MuiButton>
    )
  }
}

export default Button
